import React from "react"
export function Service(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M18 16.045V18H2v-1.955h16zM10 6.23c4.318 0 7.837 3.355 7.994 7.552l.006.294H2C2 9.744 5.582 6.23 10 6.23zM7.41 8.237l-.273.203c-1.144.902-1.847 2.086-2.084 3.514l-.047.333 1.988.217.04-.28A3.542 3.542 0 018.354 10l.225-.17-1.17-1.592zM10 1c1.105 0 2 .878 2 1.962 0 1.083-.895 1.961-2 1.961s-2-.878-2-1.961C8 1.878 8.895 1 10 1z"
        fill="currentColor"
        id="prefix__service"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
